import { useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import UtilsFormule from "../../../../../utils/UtilsFormule";
import UtilsUrl from "../../../../../utils/UtilsUrl";


const DataTableOperations =(listOperation)=>{
    console.log("listOperation", listOperation.listOperation);
  const [transactions, setTransactions] = useState(listOperation.listOperation);
  // const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [openInfoAlert, setOpenInfoAlert] = useState(false);

  const { SearchBar } = Search;
  const MyExportCSV = (props) => {
    const handleClick = () => {
      props.onExport();
    };
    return (
      <div>
        <button className="btn btn-dark" onClick={handleClick}>
          <i class="fas fa-download"></i> Télécharger CSV
        </button>
      </div>
    );
  };


  // function refFormatter(cell, row) {
  //   console.log("row", row);
  //   if (row.facture !== null) {
  //     return <span>{row.facture.ref}</span>;
  //   } else if (row.purchaseOrder !== null) {
  //     return <span>{row.purchaseOrder.refPo}</span>;
  //   }
  // }
  function titleFormatter(cell,row) {
    console.log("titleFormatter",row)
      return <span>{row.operation.code}-{row.operation.name}</span>;
    
  }
  function uniteFormatter(cell,row) {
    return <span>{row.workstation.code}-{row.workstation.name}</span>;
  
}

  const columns = [
    {
      dataField: "id",
      text: "Operation",
      align: "center",
      headerAlign: "center",
      formatter: titleFormatter,

     
    },
    {
      dataField: "setupTime",
      text: "setupTime  (s)",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
      
    },
    {
      dataField: "transferTime",
      text: "transferTime (s)",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
      
    },
    {
      dataField: "workstation.id",
      text: "Unité de travail",
      align: "center",
      headerAlign: "center",
      formatter: uniteFormatter,

      headerStyle: () => {
        return { width: "15%" };
      },
      
    }
    
  ];
  

  // const rates = (element) => {
  //   if (element.productPurchaseHistories.length !== 0) {
  //     console.log("productPurchaseHistories", element.productPurchaseHistories);
  //     return (
  //       <div class="col-md-12">
  //         <div class="card card-dark collapsed-card">
  //           <div class="card-header">
  //             <h3 class="card-title">Les opérations de réception</h3>
  //             <div class="card-tools">
  //               <button
  //                 type="button"
  //                 class="btn btn-tool"
  //                 data-card-widget="collapse"
  //               >
  //                 <i class="fas fa-plus"></i>
  //               </button>
  //             </div>
  //           </div>

  //           <div class="card-body">
  //             {listRates(element.productPurchaseHistories)}
  //           </div>
  //         </div>
  //       </div>
  //     );
  //   }
  // };
  // const listRates = (list) => {
  //   return (
  //     <table
  //       class="table table-striped table-bordered table-sm"
  //       cellspacing="0"
  //       width="100%"
  //     >
  //       <thead>
  //         <tr className="text-center">
  //           <th>Libellé</th>

  //           <th style={{ width: "15%" }}>Opération</th>
  //           <th style={{ width: "15%" }}>Note</th>
  //           <th style={{ width: "15%" }}>DC</th>
  //           <th style={{ width: "15%" }}>Responsable</th>
  //           <th style={{ width: "8%" }}>Q.R</th>
  //           <th style={{ width: "8%" }}>Q.T</th>
  //         </tr>
  //       </thead>
  //       <tbody>
  //         {list &&
  //           list.map((element, i) => (
  //             <tr key={i}>
  //               <td>{element.productPurchase.product.name}</td>

  //               <td className="text-center">{typeFormatter(element.type)} </td>
  //               <td>{element.note}</td>

  //               <td>{UtilsFormule.formatDateHours(element.creationDate)} </td>
  //               <td>
  //                 <span>
  //                   {element.creator.firstName} {element.creator.lastName}
  //                 </span>
  //               </td>

  //               <td className="text-center">{element.quantity} </td>

  //               <td className="text-center">
  //                 {element.productPurchase.quantity}
  //               </td>
  //             </tr>
  //           ))}
  //       </tbody>
  //     </table>
  //   );
  // };
  // function typeFormatter(type) {
  //   if (type === 1) {
  //     return <span className="badge bg-success">Nouvel arrivage</span>;
  //   } else if (type === 2) {
  //     return <span className="badge bg-warning">Refusé</span>;
  //   } else if (type === 3) {
  //     return <span className="badge bg-primary">Arrivage du retours</span>;
  //   }
  // }

  const importProduct = (row) => {
    return (
      <div>
    
      </div>
    );
  };
  const expandRow = {
    renderer: (row) => importProduct(row),
    showExpandColumn: true,
    expandByColumnOnly: true,
    expandHeaderColumnRenderer: ({ isAnyExpands }) => {
      if (isAnyExpands) {
        return <b>-</b>;
      }
      return <b>+</b>;
    },
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return <b>-</b>;
      }
      return <b>+</b>;
    },
  };

  // const handleInfoClose = (event, reason) => {
  //   if (reason === "clickaway") {
  //     return;
  //   }
  //   setOpenInfoAlert(false);
  // };

  function handleTableChange({ products }) {
    return products;
  }
  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };

  return (
     
     
        <ToolkitProvider
          keyField="id"
          data={transactions}
          columns={columns}
        >
          {(props) => (
            <div>
           
              <div className="row">
                <BootstrapTable
                  {...props.baseProps}
                  pagination={paginationFactory(options)}
                  striped
                  hover
                  condensed
                  expandRow={expandRow}
                />
              </div>
            </div>
          )}
        </ToolkitProvider>
   
  );
}
export default DataTableOperations;